import { ComponentRenderProps, useDataValue } from '@json-render/react';

type TextProps = ComponentRenderProps & {
  element: {
    props: {
      content: string | null;
      valuePath: string | null;
    };
    children?: string[];
  };
};

export function Text({ element }: TextProps) {
  const { content, valuePath } = element.props;

  const dynamicValue = useDataValue(valuePath ?? '');
  const displayValue = valuePath ? String(dynamicValue ?? '') : (content ?? '');

  return <p className="text-sm">{displayValue}</p>;
}
